import Plyr from 'plyr';
import { closeModal, initModal, toggleModal } from '../components/modal';
import { docReady } from '../utils/docReady';
const videoLightboxSelectors = {
    trigger: '[data-video-lightbox-trigger]',
    video: '[data-plyr-video], video',
    lightbox: '[data-video-lightbox]',
};
const init = () => {
    const videoTriggers = document.querySelectorAll(videoLightboxSelectors.trigger);
    const videoElems = document.querySelectorAll(videoLightboxSelectors.video);
    const modelElems = document.querySelectorAll(videoLightboxSelectors.lightbox);
    const players = [];
    modelElems.forEach((modelSection) => {
        const options = {
            controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
            clickToPlay: true,
            volume: 1,
        };
        if (videoElems) {
            [...videoElems].map((video) => {
                const player = new Plyr(video, options);
                players.push(player);
                const modalCloseButtons = modelSection.querySelectorAll('[data-modal-close]');
                modalCloseButtons.forEach((button) => {
                    const closeID = button.dataset.modalClose;
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        [...players].map((ply) => {
                            ply.pause();
                        });
                        closeModal(closeID);
                    });
                });
            });
        }
        if (videoTriggers) {
            videoTriggers.forEach((trigger) => {
                const modalID = trigger.dataset.videoLightboxId;
                initModal(modalID);
                trigger.addEventListener('click', (event) => {
                    event.preventDefault();
                    toggleModal(modalID);
                    if (players.length > 0) {
                        players[0].play();
                    }
                });
            });
        }
    });
};
docReady(init());
